import {generateChart} from './DefaultChart'
import {reactiveData} from './mixins/data-update'

const Line = generateChart('LineChart', 'SuperDuperLine')

export default {
  extends: Line,
  mixins: [reactiveData],
  props: {
    dataToRender: {
      type: Object,
      default: () => [],
      required: true
    },
    displayDots: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    dataToRender: {
      handler: function (newData, oldData)
      {
        // if (!this.chartData) this.initChart();
        if (JSON.stringify(newData) !== JSON.stringify(oldData))
        {
          setTimeout(this.fillData.bind(this, newData), 0)
        }
      },
      deep: true,
      immediate: true
    },
    displayDots: {
      handler: function (newValue)
      {
        if (this.chartData)
        {
          this.chartData.datasets[0].pointRadius = newValue ? 5 : 0
        }
        if (this.$data._chart)
        {
          this.$data._chart.update()
        }
      },
      immediate: true
    }
  },
  data()
  {
    return {
      chartData: null,
      options: {
        interaction: {
          mode: 'interpolate',
          intersect: false
          // axis: "x"
        },
        plugins: {
          legend: {
            display: true,
            position: 'bottom',
            labels: {
              usePointStyle: true
            }
          },
          tooltip: {
            displayColors: true,
            usePointStyle: true,
            mode: 'index',
            intersect: false,
            yAlign: 'bottom',
            cornerRadius: 16,
            caretPadding: 8,
            caretSize: 8,
            backgroundColor: '#F5FBFF',
            bodyColor: '#0C2D45',
            bodyFont: {
              family: 'Open Sans',
              weight: 14,
              size: 16
            },
            titleMarginBottom: 0,
            titleSpacing: 0,
            footerMarginTop: 0,
            footerSpacing: 0,
            padding: {
              top: 12,
              bottom: 12,
              left: 16,
              right: 16
            },
            bodySpacing: 0,
            callbacks: {
              beforeTitle: function () { },
              title: function () { },
              labelTextColor: function () {
                return 'black'
              },
              beforeLabel: function () {
                return ''
              },
              label: function (context) {
                let label = context.dataset.label || ''

                if (label) {
                  label += ': '
                }
                if (context.formattedValue !== null) {
                  label += '€' + context.formattedValue
                }
                return label
              }
            }
          }
        },
        scales: {
          y: {
            display: true,
            grid: {
              drawBorder: false,
              color: '#E2F3FF'
            },
            ticks: {
              color: '#071D2D',
              font: {
                family: 'Montserrat',
                weight: 600
              },
              // autoSkipPadding: 84,
              padding: 44,
              // labelOffset: -15,
              callback: function (val, index) {
                // Hide the label of every 2nd dataset
                return '€' + this.getLabelForValue(val)
              }
              // stepSize: 84
            }
          },
          x: {
            display: true,
            grid: {
              drawBorder: false,
              color: '#E2F3FF'
            },
            ticks: {
              padding: 16,
              color: '#071D2D',
              font: {
                family: 'Montserrat',
                weight: 600
              }
            }
          }
        },
        animation: {
          easing: 'easeInOutBack'
        },
          elements: {
            point: {
              radius: 0
            }
          },
        responsive: true,
        datasetStrokeWidth: 3,
        pointDotStrokeWidth: 4,
        tooltipFontStyle: 'bold',
        showScale: false,
        maintainAspectRatio: false
      }
    }
  },
  mounted() {
    if (this.chartData) {
      this.renderChart(this.chartData, this.options)
    }
  },
  methods: {
    fillData(data = [])
    {
      // TODO CHANGE order on BE!
      const test = data.datasets[0]
      const test2 = data.datasets[1]
      data.datasets[0] = test2
      data.datasets[1] = test
      // console.log(data)
      this.chartData = data
      // data.forEach(([label, value], index) => {
      //   this.chartData.labels.push(label)
      //   this.chartData.datasets[0].data.push(value)
      // })
    }
  }
}
